import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Title, List, Item } from './styled';

class CallToActionText extends PureComponent {

    static propTypes = {
        title: PropTypes.string,
        items: PropTypes.array
    };

    static defaultProps = {
        title: 'Как подключиться?',
        items: []
    };

    render() {

        const { title, items } = this.props;

        const { renderItems } = this;

        return (
            <Wrapper ref={node => this.wrapperText = node} >
                <Title ref={node => this.titleText = node}>{title}</Title>
                <List>
                    {renderItems(items)}
                </List>
            </Wrapper>
        );
    }

    renderItems = items => items.map(item => {
        const currentKey = String(Math.random()) + Date.parse(new Date());
        return (
            <Item key={currentKey}>
                <span dangerouslySetInnerHTML={{ __html: item }} />
            </Item>
        );
    });

    componentDidMount() {
        this.restylingComponent();
        if (process.browser) {
            window.addEventListener('resize', this.restylingComponent);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.restylingComponent);
    }

    restylingComponent = () => {
        const { wrapperText, titleText } = this;
        if (wrapperText.offsetWidth < 453) {
            wrapperText.style.padding = '35px 20px';
            titleText.style.fontSize = '20px';
        } else {
            wrapperText.style.padding = '35px 36px';
            titleText.style.fontSize = '24px';
        }
    }
}

export default CallToActionText;
